import { render } from "./CheckField.vue?vue&type=template&id=0889eca8"
import script from "./CheckField.vue?vue&type=script&lang=js"
export * from "./CheckField.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__